import moment from 'moment-timezone';
import Utils from '../components/Utils';

const DateRangeUtils = {
    toLabel: (startDate: Date | null, endDate: Date | null): string => {
        let keywords: string[] = [];

        if (startDate) {
            keywords.push(moment(Utils.getDate(startDate)).format('MMMM DD YYYY'));
        }

        if (endDate) {
            keywords.push(moment(Utils.getDate(endDate)).format('MMMM DD YYYY'));
        }

        return keywords.join(' - ');
    },
};

export default DateRangeUtils;
